import { useUpdateAccessKey } from '@api/accessKeys';
import React from 'react';
import { AccessKeyType } from 'types/accessKeys';
import { IRowActionDialogProps } from 'types/common';
import AccessKeyEditDialog from '../Helpers/AccessKeyEditDialog';

const EditDialog: React.FC<IRowActionDialogProps> = (props) => {
	const updateAccessKeyMutation = useUpdateAccessKey();

	return (
		<AccessKeyEditDialog
			{...props}
			mutation={updateAccessKeyMutation}
			accessKeyType={AccessKeyType.access}
			showTenantMapping
		/>
	);
};

export default EditDialog;
